import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px",
  "data-kt-menu": "true"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-column bgi-no-repeat rounded-top\" style=\"background-image:url(&#39;media/misc/pattern-1.jpg&#39;);\"><h3 class=\"text-white fw-bold px-9 mt-10 mb-6\"> Account List <span class=\"fs-8 opacity-75 ps-3\"></span></h3><ul class=\"nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9\"><li class=\"nav-item\"><a class=\"nav-link text-white opacity-75 opacity-state-100 pb-4\" data-bs-toggle=\"tab\" href=\"#kt_topbar_notifications_3\">UserIds</a></li></ul></div>", 1)
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = {
  class: "tab-pane fade show active",
  id: "kt_topbar_notifications_3",
  role: "tabpanel"
}
const _hoisted_5 = { class: "scroll-y mh-325px my-5 px-8" }
const _hoisted_6 = { class: "d-flex align-items-center me-2" }
const _hoisted_7 = {
  href: "javascript:;",
  class: "text-gray-800 text-hover-primary fw-bold"
}
const _hoisted_8 = {
  key: 0,
  class: "badge badge-success fs-8"
}
const _hoisted_9 = {
  key: 0,
  class: "d-flex flex-stack py-4"
}
const _hoisted_10 = { class: "d-flex align-items-center me-2" }
const _hoisted_11 = {
  href: "javascript:;",
  class: "text-gray-800 text-hover-primary fw-bold"
}
const _hoisted_12 = {
  key: 0,
  class: "badge badge-success fs-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_ctx.isBibo == false)
            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.accountlist, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: "d-flex flex-stack py-4"
                }, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("span", {
                      class: ["w-70px badge me-4", `badge-light-primary`]
                    }, _toDisplayString(item.usid), 1),
                    _createVNode("a", _hoisted_7, _toDisplayString(_ctx.numberWithCommas(item.balance)) + " " + _toDisplayString(item.ccy3), 1)
                  ]),
                  (_ctx.currentUsid === item.usid)
                    ? (_openBlock(), _createBlock("span", _hoisted_8, " Current"))
                    : (_openBlock(), _createBlock("span", {
                        key: 1,
                        class: "badge badge-light fs-8",
                        onClick: ($event: any) => (_ctx.changeAccount(item.usid)),
                        style: {"cursor":"pointer"}
                      }, " Browse", 8, ["onClick"]))
                ]))
              }), 128))
            : _createCommentVNode("", true),
          (_ctx.isBibo == true)
            ? (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.accountlist, (item, index) => {
                return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                  (index == 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_9, [
                        _createVNode("div", _hoisted_10, [
                          _createVNode("span", {
                            class: ["w-70px badge me-4", `badge-light-primary`]
                          }, _toDisplayString(item.usid), 1),
                          _createVNode("a", _hoisted_11, _toDisplayString(_ctx.numberWithCommas(item.balance)) + " " + _toDisplayString(item.ccy3), 1)
                        ]),
                        (_ctx.currentUsid === item.usid)
                          ? (_openBlock(), _createBlock("span", _hoisted_12, " Current"))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}